import React from "react";
import { Spacer, Stack, Typography } from "digiwash-components";
import CustomIcon from "../../components/CustomIcon";

interface PropTypes {
  name: string;
  value: string;
  hasBottomDivider?: boolean;
  icon?: string;
}

function InvoiceRowNew(props: PropTypes) {
  return (
    <>
      <Stack distribution="space-between">
        <Stack>
          {props.icon ? (
            <>
              <CustomIcon icon={props.icon} width={16} height={16} />
              <Spacer size="s" />
            </>
          ) : null}
          <Typography color="gray.light950" ff="mainMedium">
            {props.name}
          </Typography>
        </Stack>
        <Typography color="gray.light950" fs="xm">
          {props.value}
        </Typography>
      </Stack>
    </>
  );
}
export default InvoiceRowNew;
